import React from 'react'

const McqFormation = ({ question }) => {
    // Calculate max length of all options to determine layout
    const calculateMaxLength = () => {
        const options = [
            question?.finaloption1,
            question?.finaloption2,
            question?.finaloption3,
            question?.finaloption4
        ].filter(Boolean); // Remove null/undefined values

        if (options.length === 0) return 0;

        return Math.max(...options.map(option => {
            // Strip HTML tags for length calculation
            let text = option?.replace(/\u003c[^\u003e]*\u003e/g, '') || '';
            
            // Remove common HTML entities
            text = text.replace(/&nbsp;/g, ' ')
                      .replace(/&lt;/g, '\u003c')
                      .replace(/&gt;/g, '\u003e')
                      .replace(/&amp;/g, '&')
                      .trim();
            
            return text.length;
        }));
    };

    const maxLength = calculateMaxLength();

    // Updated 3-tier layout system for MCQ options:
    // - Very short options (≤10 chars): 25% width = 4 options per line
    // - Standard options (11-40 chars): 50% width = 2 options per line
    // - Long options (>40 chars): 100% width = 1 option per line
    let optionWidth = "100%";
    if (maxLength <= 10) {
        optionWidth = "25%";
    } else if (maxLength <= 40) {
        optionWidth = "50%";
    }

    return (
        <div>
            <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                marginTop: '10px',
                gap: '5px' 
            }}>
                {(question?.option1_img || question?.finaloption1) &&
                    <div style={{ 
                        display: "flex", 
                        gap: "5px", 
                        width: optionWidth,
                        boxSizing: "border-box",
                        paddingRight: optionWidth !== "100%" ? "10px" : "0",
                        whiteSpace: optionWidth === "100%" ? "normal" : (maxLength > 20 ? "normal" : "nowrap"),
                        overflow: "visible"
                    }}>
                        <span style={{ flexShrink: 0 }}>A.</span>
                        <div style={{
                            flex: 1,
                            overflow: "visible",
                            textOverflow: "clip"
                        }} dangerouslySetInnerHTML={{
                            __html: question?.finaloption1,
                        }} />
                        {question?.option1_img && <img
                            style={{
                                maxWidth: "160px",
                                height: "auto",
                                flexShrink: 0
                            }}
                            src={question?.option1_img}
                            alt="Option A"
                        />}
                    </div>}
                {(question?.option2_img || question?.finaloption2) &&
                    <div style={{ 
                        display: "flex", 
                        gap: "5px", 
                        width: optionWidth,
                        boxSizing: "border-box",
                        paddingRight: optionWidth !== "100%" ? "10px" : "0",
                        whiteSpace: optionWidth === "100%" ? "normal" : (maxLength > 20 ? "normal" : "nowrap"),
                        overflow: "visible"
                    }}>
                        <span style={{ flexShrink: 0 }}>B.</span>
                        <div style={{
                            flex: 1,
                            overflow: "visible",
                            textOverflow: "clip"
                        }} dangerouslySetInnerHTML={{
                            __html: question?.finaloption2,
                        }} />
                        {question?.option2_img && <img
                            style={{
                                maxWidth: "160px",
                                height: "auto",
                                flexShrink: 0
                            }}
                            src={question?.option2_img}
                            alt="Option B"
                        />}
                    </div>}
                {(question?.option3_img || question?.finaloption3) &&
                    <div style={{ 
                        display: "flex", 
                        gap: "5px", 
                        width: optionWidth,
                        boxSizing: "border-box",
                        paddingRight: optionWidth !== "100%" ? "10px" : "0",
                        whiteSpace: optionWidth === "100%" ? "normal" : (maxLength > 20 ? "normal" : "nowrap"),
                        overflow: "visible"
                    }}>
                        <span style={{ flexShrink: 0 }}>C.</span>
                        <div style={{
                            flex: 1,
                            overflow: "visible",
                            textOverflow: "clip"
                        }} dangerouslySetInnerHTML={{
                            __html: question?.finaloption3,
                        }} />
                        {question?.option3_img && <img
                            style={{
                                maxWidth: "160px",
                                height: "auto",
                                flexShrink: 0
                            }}
                            src={question?.option3_img}
                            alt="Option C"
                        />}
                    </div>}
                {(question?.option4_img || question?.finaloption4) &&
                    <div style={{ 
                        display: "flex", 
                        gap: "5px", 
                        width: optionWidth,
                        boxSizing: "border-box",
                        paddingRight: optionWidth !== "100%" ? "10px" : "0",
                        whiteSpace: optionWidth === "100%" ? "normal" : (maxLength > 20 ? "normal" : "nowrap"),
                        overflow: "visible"
                    }}>
                        <span style={{ flexShrink: 0 }}>D.</span>
                        <div style={{
                            flex: 1,
                            overflow: "visible",
                            textOverflow: "clip"
                        }} dangerouslySetInnerHTML={{
                            __html: question?.finaloption4,
                        }} />
                        {question?.option4_img && <img
                            style={{
                                maxWidth: "160px",
                                height: "auto",
                                flexShrink: 0
                            }}
                            src={question?.option4_img}
                            alt="Option D"
                        />}
                    </div>}
            </div>
        </div>
    )
}

export default McqFormation